import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';
import {User} from '../../../models/user';

export class UpdateUsersAction implements Action {
  public static readonly type = 'UpdateUsersAction';

  constructor(public bijbEvent: BijbEvent, public users: User[]) {
  }

  public type = UpdateUsersAction.type;
}
